import type { RelatedPlace } from "~/lib/api";
import { isMtbTrailRelatedPlace } from "~/lib/api";
import type { RelatedPlaceCategory } from "~/lib/relatedPlaces";
import { TrailListItem } from "~/components/place/mtb/TrailListItem";
import { RelatedPlacesSection } from "~/components/landing/RelatedPlacesSection";

interface BikeParkLandingSectionProps {
  relatedPlaces: RelatedPlace[];
  onSelect: (place: RelatedPlace) => void;
}

const NEARBY_CATEGORIES: RelatedPlaceCategory[] = [
  { label: "Bike Shops", emptyLabel: "", icon: "bike-shop", types: ["bike-shop"] },
  { label: "Eats & Drinks", emptyLabel: "", icon: "restaurant", types: ["restaurant", "cafe", "bar"] },
  { label: "Places to Stay", emptyLabel: "", icon: "accommodation", types: ["accommodation"] },
  { label: "Other spots", emptyLabel: "", icon: "map-pin", types: null },
];

export function BikeParkLandingSection({ relatedPlaces, onSelect }: BikeParkLandingSectionProps) {
  const trails = relatedPlaces.filter(isMtbTrailRelatedPlace);
  const nearby = relatedPlaces.filter((p) => !isMtbTrailRelatedPlace(p));

  if (trails.length === 0 && nearby.length === 0) return null;

  return (
    <div className="space-y-5">
      {trails.length > 0 && (
        <div>
          <h3 className="text-sm font-medium text-foreground mb-2">Trails</h3>
          <div className="flex flex-col">
            {trails.map((trail) => (
              <TrailListItem key={trail.id} place={trail} onSelect={() => onSelect(trail)} />
            ))}
          </div>
        </div>
      )}
      {trails.length > 0 && nearby.length > 0 && <hr className="border-border" />}
      {nearby.length > 0 && (
        <RelatedPlacesSection relatedPlaces={nearby} onSelect={onSelect} categories={NEARBY_CATEGORIES} />
      )}
    </div>
  );
}
